import { useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";
import type { MeDto } from "@ambulance/shared";
import { useApi } from "../api";

/** The signed-in user's profile from the API (undefined while loading, null when signed out). */
export function useMe() {
  const auth = useAuth();
  const api = useApi();
  const q = useQuery({
    queryKey: ["me", api.token],
    queryFn: () => api.get<MeDto>("/api/v1/me"),
    enabled: Boolean(api.token),
    staleTime: 60_000,
  });
  if (!auth.isAuthenticated && !auth.isLoading) return { me: null as MeDto | null, isLoading: false, error: null };
  return { me: q.data, isLoading: auth.isLoading || q.isPending, error: q.error };
}
